export const socketFr = {
    connection: {
        disconnected: 'Connexion perdue. Veuillez rafraichir la page.'
    }
}
